type SaleOrRent = 'sale' | 'rent';

interface MapMarkerDTO {
  // vendor API DTO
  id: string;
  list_price: number | null;
  sale_or_rent: string | null;
  latitude: number;
  longitude: number;
}

export class MapMarker {
  constructor(
    public readonly propertyId: string,
    public readonly lat: number,
    public readonly lng: number,
    public readonly listPrice: number | null,
    public readonly saleOrRent: SaleOrRent | null
  ) {
    if (!propertyId) throw new Error('MapMarker requires propertyId');
    if (lat < -90 || lat > 90) throw new Error('Invalid latitude');
    if (lng < -180 || lng > 180) throw new Error('Invalid longitude');
  }

  static fromDTO(dto: MapMarkerDTO): MapMarker | null {
    try {
      return new MapMarker(
        dto.id,
        dto.latitude,
        dto.longitude,
        dto.list_price ?? null,
        (dto.sale_or_rent as SaleOrRent) ?? null
      );
    } catch (error) {
      console.error('Error creating MapMarker from DTO', error);
      return null;
    }
  }
}
